import { createAction } from '@'
import axios from 'axios'
import { getAuth, loginErrorHandle } from '../../@misc'

const ENDPOINT = process.env.REACT_APP_API_URL

export default createAction('EditRole', async params => {
    const auth = getAuth()

    try {
        await axios({
            url: `${ENDPOINT}/roles/${params.id}`,
            method: 'PUT',
            headers: { 'Content-Type': 'application/json', ...auth },
            data: {
                description: params.description,
                permissions: params.permissions
            }
        })
    } catch (e) {
        loginErrorHandle(e)
        console.error(e)
    }

    if (params.onSuccess) {
        await params.onSuccess()
    }
})
